import { useTranslation } from "react-i18next";
import { useNotifsStore } from "../../stores/Utils/notifs";

const Help = () => {
  const { t } = useTranslation();
  const { showHelp } = useNotifsStore();

  return (
    <>
      {showHelp && (
        <div
          className="fixed bottom-16 left-2 right-2 z-40 flex h-[150px] flex-col items-center justify-center rounded-xl bg-white p-4 font-BarlowCondensed shadow-2xl sm:absolute sm:bottom-auto sm:left-14 sm:right-auto sm:top-[240px] sm:w-[300px] xl:w-[450px]"
        >
          <p className="text-center font-BarlowCondensed text-md w-full bg-yellow-trio rounded-md sticky top-0 z-10">
            {t("help.title")}
          </p>
          <p className="text-center font-BarlowCondensed text-md w-full rounded-md ">
            {t("help.text")}
          </p>
          <a
            href="mailto:dev@trionode.com"
            className="font-bold text-center w-full"
          >
            dev@trionode.mc
          </a>
        </div>
      )}
    </>
  );
};

export default Help;